module.exports = __webpack_public_path__ + "static/media/icon-signal-dark.f0fa256e.svg";